
import SourceWrap from './source-wrap.vue'
import SourcePopover from './source-popover.vue'
import SourceIcon from './source-icon.vue'
import SourceType from './source-type.vue'

export default {
  components: {SourceWrap, SourceIcon, SourcePopover, SourceType},
  props: {
    data: {type: Object, default: undefined},
    disabled: {type: Boolean, default: false},
    num: {type: Number, default: undefined},
  },
  data() {
    return {
      popup_visible: false,
    }
  },
  computed: {
    internal(){
      return this.data?.internal
    },
    type(){
      return this.internal ? 'internal' : this.data?.type
    },
    name(){
      return this.data?.name
    }
  }
}
